var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageEl",staticClass:"page",on:{"scroll":_vm.updateScrollPosition}},[_c('navbar-conference'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}],staticClass:"loader disable"}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-conference')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }